import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    list: '',
    code: ""
}
const mutations = {

    SET_DATAS(state, lists) {
        state.list = lists
    },
    STATUS_CODE(state, code) {
        state.code = code
    },

}
const actions = {
    fetchLists({
        commit,
        rootState
    }, data) {

        return AppService.dashboard.getDashboard(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateTheme({
        commit,
        rootState
    }, data) {

        return AppService.dashboard.postupdateTheme(data, rootState.session.token)
            .then((response) => {
                commit('STATUS_CODE', response.status)
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    }
}
export default {
    namespaced,
    state,
    mutations,
    actions
}